import { subDays, subMonths } from 'date-fns'
import { getCurrentDate } from './getDates'

//if dateType is week - show data for the last 12 weeks
//if dateType is month - show data for the last 12 months
//if dateType is day - show data for the last 7 days

export const getChartStartDate = (
  dateType: 'day' | 'week' | 'month',
  timezone: string
) => {
  switch (dateType) {
    case 'week':
      //start date should be the first day of the week
      return subDays(
        new Date(getCurrentDate(timezone)),
        77 + new Date(getCurrentDate(timezone)).getDay() - 1
      )
    case 'month':
      //start date should be the first day of the month
      const yearAgo = subMonths(new Date(getCurrentDate(timezone)), 11)
      return new Date(yearAgo.getFullYear(), yearAgo.getMonth(), 1)
    default:
      return subDays(new Date(getCurrentDate(timezone)), 6)
  }
}
